import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import GeneralHelper from '../../../helpers/general';

import './OrderConfirmation.less';
import LocalStorageHelper from '../../../helpers/local_storage';

const OrderConfirmation = ({ order, onProceedToPayment, bookingState, loading, timeslot }) => {
	const { meal, drink } = order;

	const mealCustomizations = meal?.chosen_meal_customizations || [];
	const drinkCustomizations = drink?.chosen_drink_customizations || [];

	const [email, setEmail] = useState(LocalStorageHelper.getUserEmail());
	const [emailError, setEmailError] = useState('');

	const mealCustomizationsTotal = mealCustomizations.reduce((sum, item) => sum + (item?.selected_options?.price || 0), 0);
	const drinkCustomizationsTotal = drinkCustomizations.reduce((sum, item) => sum + (item?.selected_options?.price || 0), 0);

	const total = (meal?.meal_price || 0) + (drink?.drink_price || 0) + mealCustomizationsTotal + drinkCustomizationsTotal;

	const handleEmailChange = (e) => {
		const value = e.target.value;
		setEmail(value);
		if (emailError && value && GeneralHelper.isEmailValid(value)) {
			setEmailError('');
		}
	};

	const handleProceedToPayment = () => {
		if (loading) {
			return;
		}
		if (!email) {
			setEmailError('Please enter your email address');
			return;
		}
		if (!GeneralHelper.isEmailValid(email)) {
			setEmailError('Please enter a valid email address');
			return;
		}
		LocalStorageHelper.setUserEmail(email);
		onProceedToPayment(email);
	};

	return (
		<div className="order-confirmation">
			<div className="order-confirmation-header">
				<div className="order-confirmation-icon-wrapper">
					<FontAwesomeIcon
						icon={faCreditCard}
						className="order-confirmation-icon"
					/>
				</div>
				<h2 className="order-confirmation-title">訂單預覽 Order Preview</h2>
				{/* <p className="order-confirmation-subtitle">Proceed to payment</p> */}
			</div>

			<div className="email-input-card">
				<h3 className="email-input-title">電郵地址 Email Address</h3>
				<p className="email-input-subtitle">訂單狀態更新時將發送通知 Notification will be sent on status update</p>
				<input
					type="email"
					className={`email-input ${emailError ? 'email-input-error' : ''}`}
					placeholder="Enter your email"
					value={email}
					onChange={handleEmailChange}
				/>
				{emailError && <p className="email-error-message">{emailError}</p>}
			</div>

			<div className="order-summary-card">
				<h3 className="order-summary-title">訂單摘要 Order Summary</h3>

				<div className="order-summary-items">
					<div className="order-summary-item">
						<span className="item-name">Pickup Time</span>
						<span className="item-price">{dayjs(timeslot.timeslot_start_time).format('HH:mm')} - {dayjs(timeslot.timeslot_end_time).format('HH:mm')}</span>
					</div>

					<div className="order-summary-divider"></div>

					{meal && (
						<div className="order-summary-item">
							<span className="item-name">{meal.meal_name}</span>
							<span className="item-price">${(meal.meal_price || 0).toFixed(2)}</span>
							{mealCustomizations && mealCustomizations.length ? (
								<ul className="order-summary-item-options">
									{
										mealCustomizations.map((customization) => (
											<li
												style={{ display: 'flex', justifyContent: 'space-between' }}
												key={customization.customization_id}
											>
												<span className="label">{customization.selected_options.label}</span>
												{
													customization.selected_options.price < 0 ?
														<span className="price">- ${customization.selected_options.price.toFixed(2).split('-')[1]}</span>
														: <span className="price">${customization.selected_options.price.toFixed(2)}</span>
												}
											</li>
										))
									}
								</ul>
							) : null}
						</div>
					)}

					{
						(mealCustomizations && mealCustomizations.length) && (drinkCustomizations && drinkCustomizations.length) ?
							<div className="order-summary-divider"></div>
							: null
					}

					{drink && drink.drink_price > 0 && (
						<div className="order-summary-item">
							<span className="item-name">{drink.drink_name}</span>
							<span className="item-price">${drink.drink_price.toFixed(2)}</span>
							{drinkCustomizations && drinkCustomizations.length ? (
								<ul className="order-summary-item-options">
									{
										drinkCustomizations.map((customization) => (
											<li
												style={{ display: 'flex', justifyContent: 'space-between' }}
												key={customization.customization_id}
											>
												<span className="label">{customization.selected_options.label}</span>
												{
													customization.selected_options.price < 0 ?
														<span className="price">- ${customization.selected_options.price.toFixed(2).split('-')[1]}</span>
														: <span className="price">${customization.selected_options.price.toFixed(2)}</span>
												}
											</li>
										))
									}
								</ul>
							) : null}
						</div>
					)}
				</div>

				<div className="order-summary-divider"></div>


				<div className="order-summary-total">
					<span className="total-label">總額 Total</span>
					<span className="total-amount">${total.toFixed(2)}</span>
				</div>
			</div>

			<div className="order-terms">
				<p className="terms-text">
					點擊「前往付款」即表示您同意我們的
					<Link
						target="_blank"
						to={{
							pathname: '/terms',
							state: { bookingState }
						}}
						className="terms-link"
					>
						條款及細則
					</Link>
					。
				</p>
				<p className="terms-text">
					By tapping Proceed to Payment, you agree to our{' '}
					<Link
						target="_blank"
						to={{
							pathname: '/terms',
							state: { bookingState }
						}}
						className="terms-link"
					>
						Terms & Conditions
					</Link>
					.
				</p>
			</div>

			<div className="order-confirmation-footer">
				<button
					className="proceed-to-payment-btn"
					onClick={handleProceedToPayment}
					disabled={loading}
				>
					{loading ? '處理中 Processing...' : '前往付款 Proceed to Payment'}
				</button>
			</div>
		</div>
	);
};

export default OrderConfirmation;
